import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/LoadCustomerDetails'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class LoadCustomerDetailsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "LoadCustomerDetailsStore",
			variables: true,
		})
	}
}

export async function load_LoadCustomerDetails(params) {
  await initClient()

	const store = new LoadCustomerDetailsStore()

	await store.fetch(params)

	return {
		LoadCustomerDetails: store,
	}
}
